import React from 'react'
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faScaleBalanced,
    faPhone,
    faEnvelope,

} from "@fortawesome/free-solid-svg-icons";


const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { staggerChildren: 0.1 }
    }
};

const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.8, ease: "easeOut" }
    }
};
export const Cta = ({ Title, description }) => {
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    return (
        <div>
            {/* CTA Section */}
            <motion.div
                className="text-center px-3"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={containerVariants}
            >
                <motion.div
                    className="p-5 rounded-4 mx-auto"
                    style={{
                        backgroundColor: "var(--white)",
                        border: "2px solid var(--gold-light)",
                        boxShadow: "var(--shadow-medium)",
                        maxWidth: "800px"
                    }}
                    variants={fadeInUp}
                >
                    <FontAwesomeIcon
                        icon={faScaleBalanced}
                        className="mb-4"
                        style={{ fontSize: "3rem", color: "var(--gold)" }}
                    />
                    <h2 className="fw-bold mb-3" style={{ color: "var(--primary-dark)" }}>
                        {Title}
                    </h2>
                    <p className="mb-4 mx-auto" style={{
                        color: "var(--text-primary)",
                        maxWidth: "600px",
                        lineHeight: 1.7
                    }}>
                        {description}
                    </p>
                    <div className="d-flex flex-wrap justify-content-center gap-3">
                        <motion.a
                            href="tel:+919473425998"
                            target='_blank'
                            className="btn px-4 py-3 fw-bold d-flex align-items-center gap-2"
                            style={{
                                backgroundColor: "var(--gold)",
                                color: "var(--white)",
                                border: "none",
                                borderRadius: "8px"
                            }}
                            whileHover={{
                                scale: 1.05,
                                backgroundColor: "var(--gold-light)"
                            }}
                            whileTap={{ scale: 0.98 }}
                        >
                            <FontAwesomeIcon icon={faPhone} />
                            Call Now: +91 9473425998
                        </motion.a>

                        <motion.a
                            href={
                                isMobile
                                    ? "mailto:rnalawchambers@gmail.com"
                                    : "https://mail.google.com/mail/?view=cm&fs=1&to=rnalawchambers@gmail.com"
                            }
                            target='_blank'
                            className="btn px-4 py-3 fw-bold d-flex align-items-center gap-2"
                            style={{
                                backgroundColor: "var(--primary-blue)",
                                color: "var(--white)",
                                border: "none",
                                borderRadius: "8px"
                            }}
                            whileHover={{
                                scale: 1.05,
                                backgroundColor: "var(--blue-accent)"
                            }}
                            whileTap={{ scale: 0.98 }}
                        >
                            <FontAwesomeIcon icon={faEnvelope} />
                            Email Consultation
                        </motion.a>
                    </div>
                </motion.div>
            </motion.div>
        </div>
    )
}
